import React, { useContext, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import Hero from "../Hero/Index";
import Info from "../Info/Info";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ProductoVenta from "../ProductoVenta/ProductoVenta";
import axios from 'axios';
import { authContext } from "../../Context/AuthContext";
import { marcasContext } from "../../Context/MarcasContext";
import { Error } from "../../helpers/Error";
import useObtenerDestacados from "../../../hooks/useFetchDestacados";
import { SpinnerMarcas } from "../../helpers/SpinnerMarcas";
import { useTranslation } from "react-i18next";
import CardRelacionados from "./CardRelacionados";
import "./indexStyle.css";
import { Column, Container, Galeria, Panel } from "./styles";

const apiProductos = process.env.REACT_APP_API_PRODUCTOS;

const Productos = () => {
  const location = useLocation();
  const [marca, setMarca] = useState({});
  const [load, setLoad] = useState(false);
  const { token } = useContext(authContext);
  const { itemVisto, setItemVisto } = useContext(marcasContext);
  const { destacado, error, irADetalles, isNavigating } = useObtenerDestacados();
  const [relacionados, setRelacionados] = useState([]);
  const [t] = useTranslation("global");

  const forceProperEncoding = (url) => {
    return url.replace(/\+/g, '%2B');
  };

  const getEncodedSKU = () => {
  let sku = '';
  if (location.pathname.includes('/openbox')) {
    sku = location.pathname.split('/openbox/')[1];
  } else if (location.pathname.includes('/oferta')) {
    sku = location.pathname.split('/oferta/')[1];
  } else {
    const rawSku = location.search.split('sku=')[1] || '';
    sku = decodeURIComponent(rawSku.replace(/\+/g, '%2B'));
  }

  return encodeURIComponent(sku).replace(/\+/g, '%2B');
};


  useEffect(() => {
    const fetchProductData = async () => {
      try {
        setLoad(false);
        const encodedSku = getEncodedSKU();
        let apiUrl = '';

        if (location.pathname.includes('/openbox')) {
          apiUrl = `${apiProductos}/openbox/${encodedSku}`;
        } else if (location.pathname.includes('/oferta')) {
          apiUrl = `${apiProductos}/oferta/${encodedSku}`;
        } else {
          apiUrl = `${apiProductos}/detalle?sku=${encodedSku}`;
        }

        const finalUrl = forceProperEncoding(apiUrl);
        console.log('URL final que se enviará:', finalUrl);

        const response = await axios.get(finalUrl, {
          headers: { 'Authorization': 'Bearer ' + token },
          transformRequest: [(data, headers) => {
            return data;
          }]
        });

        setMarca(response.data.articulo || response.data || {});
        if (response.data.articuloRelacionado) {
          setRelacionados(response.data.articuloRelacionado);
        }
      } catch (err) {
        console.error('Error al obtener datos:', err);
      } finally {
        setLoad(true);
      }
    };

    fetchProductData();
  }, [location, token]);

  const getSafeImageUrl = (imageName) => {
    if (!imageName) return process.env.PUBLIC_URL + '/assets/sin-imagen.png';
    const encoded = encodeURIComponent(imageName).replace(/\+/g, '%2B');
    return `${process.env.PUBLIC_URL}/articulos/${encoded}`;
  };

  const imagenes = marca.Imagenes?.split(',').filter(Boolean) || [];

  if (error) return <Error />;
  if (!load) return <SpinnerMarcas text={'Cargando producto'} />;

  return (
    <Container>
      <Hero data={marca} />
      <Panel>
        <Column>
          <Galeria>
            <Carousel fade variant="dark">
              {imagenes.length > 0 ? (
                imagenes.map((img, index) => (
                  <Carousel.Item key={`img-${index}`}>
                    <LazyLoadImage
                      className="d-block w-100"
                      src={getSafeImageUrl(img)}
                      alt={marca.Nombre || 'Producto'}
                      effect="blur"
                    />
                  </Carousel.Item>
                ))
              ) : (
                <Carousel.Item>
                  <LazyLoadImage
                    className="d-block w-100"
                    src={getSafeImageUrl()}
                    alt="Sin imagen disponible"
                  />
                </Carousel.Item>
              )}
            </Carousel>
          </Galeria>
          <p className="imagenIlustrativa">{t("producto.imagenes-ilustrativas")}</p>
          <Info data={marca} />

          {relacionados?.length > 0 && (
            <div className="relacionados-container">
              <h4>{t("producto.productos-interes")}:</h4>
              <div className="map-destacados">
                {relacionados.slice(0, 3).map((prod) => (
                  <CardRelacionados
                    key={prod.Alias}
                    Imagen={getSafeImageUrl(prod.Imagen?.split(',')[0])}
                    Description={prod.Nombre}
                    onClick={() => irADetalles(prod, prod.Alias)}
                  />
                ))}
              </div>
            </div>
          )}
        </Column>
        <Column>
          <ProductoVenta datos={marca} />
          
          {relacionados?.length > 0 && (
            <div className="relacionados-container-mobile">
              <h4>{t("producto.productos-interes")}:</h4>
              <div className="map-destacados-mobile">
                {relacionados.slice(0, 3).map((prod) => (
                  <CardRelacionados
                    key={prod.Alias}
                    Imagen={getSafeImageUrl(prod.Imagen?.split(',')[0])}
                    Description={prod.Nombre}
                    onClick={() => irADetalles(prod, prod.Alias)}
                  />
                ))}
              </div>
            </div>
          )}
        </Column>
      </Panel>
    </Container>
  );
};

export default Productos;